// Globals
import { FC } from 'react';

// Modules
import { ImportFaqModal } from '@/modules/FaqCommon';

// Store
import { useAppDispatch } from '@/store';
import { getGeneralFaqs } from '../feature';

// Helpers
import { GetGeneralFaqsDTO } from '../dtos';

type TImportGeneralFaqModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const ImportGeneralFaqModal: FC<TImportGeneralFaqModalProps> = ({ isOpen, onClose }) => {
  const dispatch = useAppDispatch();

  const handleImported = () => {
    dispatch(getGeneralFaqs(new GetGeneralFaqsDTO({ page: 1 })));
  };

  return <ImportFaqModal isOpen={isOpen} onClose={onClose} onImported={handleImported} isGeneral />;
};

export default ImportGeneralFaqModal;
